<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Commodity Details</h3>
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Commodity Edit</h6>

        <router-link :to="{ name: 'blog-posts'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form>
                <d-form-row>
                  <!-- Email -->


                       <d-col md="5" class="form-group row">
                        <label class="col-md-5 col-form-label">Name</label>
                        <div class="col-md-7">
                          <input
                            type="text"
                            class="form-control required-field"
                            v-model="Commodity.DataModel.Data.Commodity.Name"
                            autocomplete="off"
                          />
                        </div>
                        <!-- <label style="font-weight:600">{{Commodity.DataModel.Data.Commodity.Date}}</label> -->
                      </d-col>
                         <d-col md="5" class="form-group row">
                        <label class="col-md-5 col-form-label">Unit Price</label>
                        <div class="col-md-7">
                          <input
                            type="text"
                            class="form-control required-field"
                            v-model="Commodity.DataModel.Data.Commodity.UnitPrice"
                            autocomplete="off"
                          />
                        </div>
                      </d-col>
                     <d-col md="5" class="form-group row">
                        <label class="col-md-5 col-form-label">Date</label>
                        <div class="col-md-7">
                          <input
                            type="date"
                            class="form-control required-field"
                            v-model="Commodity.DataModel.Data.Commodity.Date"
                            autocomplete="off"
                          />
                        </div>
                      </d-col>


                    <!-- Password -->




                </d-form-row>
                <br />

                <div class style="text-align:center">
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="SubmitCommodity"
                    style="margin-right:10px"
                  >Submit</d-button>
                  <d-button
                    type="button"
                    id="submit"
                    class="btn-accent"
                    @click="ClearCommodity"
                  >Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
// import VueToast from "vue-toast-notification";
// import "vue-toast-notification/dist/theme-default.css";
// Vue.use(VueToast);

export default {
  name: "Commodity",
  data() {
    return {
      Commodity: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            Commodity: {
              Id: 0,
              Date: null,
              Name: null,
              UnitPrice: null,
              UpdateDate: null,
              CheckoutType: null,
              CheckoutAmount: null,
              ReasonforCheckout: null,
              CheckoutDate: null,
              Status: {
                Name: null
              },
              CustomerId: null,
              CompanyId: null,
              CreatedBy: 1
            }
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            ServiceCommodityID: null,
            WareHouseId: 0
          }
        },
        GridInfo: {},
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {
          CommodityList: []
        },
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.ListCommodity();
    this.Commodity.SessionInfo.PageInfo.ServiceCommodityID = sessionStorage.getItem(
      "SelectedCommodityID"
    );
    this.GetByCommodity();
    this.GetByCommodity();
  },
  methods: {
    Select() {
      console.log(this.Commodity.DataModel.Data.Commodity);
    },

    SubmitCommodity() {
      let vm = this;
      if (
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Commodity.DataModel.Data.Commodity.Name
        ) &&
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Commodity.DataModel.Data.Commodity.Date
        ) &&
        Utilities.IsNotNullOrEmptyOrUndefined(
          vm.Commodity.DataModel.Data.Commodity.UnitPrice
        )
      ) {
        this.Commodity.DataModel.Data.CRUD = "Update";

        var dataString = JSON.stringify(this.Commodity.DataModel.Data);
        axios
          .post("APIScript/PHP/APIService/Commodity/Commodity.php", dataString)
          .then(function(response) {
            if (response.data.ErrorInfo == null) {
              console.log(response.data);
              // Vue.$toast.success("Save Successfully");
            } else {
              if (
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Commodity.DataModel.Data.Commodity.Date
                ) ||
                !Utilities.IsNotNullOrEmptyOrUndefined(
                  vm.Commodity.DataModel.Data.Commodity.UnitPrice
                )
              ) {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Information missing",
                  "Please provid Name, Date and Unit Price ",
                  "error"
                );
              } else {
                console.log(response.data.ErrorInfo);
                vm.$swal.fire(
                  "Oops...",
                  "Incorrect Name or Date or Unit Price !",
                  "error"
                );
              }
            }
          })
          .catch(function(response) {
            console.log(response);
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      } else {
        vm.$swal.fire(
          "Information missing",
          "Please provid Name, Date and Unit Price ",
          "error"
        );
      }
    },
    GetByCommodity() {
      var ServiceCommodity = {
        Id: this.Commodity.SessionInfo.PageInfo.ServiceCommodityID
      };
      this.Commodity.DataModel.Data.Id = ServiceCommodity.Id;
      let vm = this;
      // var DataStr = this.Commodity.DataModel.Data;
      var Token = sessionStorage.getItem("Token");
      this.Commodity.DataModel.Data.Token = Token;
      var CustomerId = sessionStorage.getItem("CustomerId");
      this.Commodity.DataModel.Data.CustomerId = CustomerId;
      this.Commodity.DataModel.Data.CRUD = "GetById";
      var dataString = JSON.stringify(this.Commodity.DataModel.Data);
      axios
        .post("APIScript/PHP/APIService/Commodity/Commodity.php", dataString)
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            // vm.Commodity.DataModel.Data = response.data.Result;
            vm.Commodity.DataModel.Data.Commodity = response.data.Result;
            //  vm.Coupon.DataModel.Data.Coupon = response.data.Result;
            console.log(vm.Commodity.DataModel.Data);
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          return response;
        });
      // CommodityService.CommodityGet(DataStr)
      //   .then(function(response) {
      //     console.log(response.data.Result);
      //     vm.Commodity.DataModel.Data.Commodity = response.data.Result;
      //   })
      //   .catch(function(response) {
      //     console.log(response.data.ErrorInfo);
      //   });
    },

    // SubmitCommodity() {
    //   this.SubmitCommodityValidation();
    //   if (this.Commodity.submitStatus == false) {
    //     CommodityService.CommodityCreate(this.Commodity.DataModel.Data);
    //     Vue.$toast.success("Save Successfully");
    //     this.$router.push("/Commodity/Commodity");
    //   }
    // },
    ListCommodity() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Commodity.DataModel.Data.Token = Token;
      this.Commodity.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Commodity.DataModel.Data);
      axios
        .post("APIScript/PHP/APIService/Commodity/Commodity.php", dataString)
        .then(function(response) {
          if (response.data.ErrorInfo == null) {
            return response;
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
           this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    },

    ClearCommodity() {
      (this.Commodity.DataModel.Data.Commodity.Name = null),
        (this.Commodity.DataModel.Data.Commodity.Date = null);
        (this.Commodity.DataModel.Data.Commodity.UnitPrice = null);
    },

    ListCommodity() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Commodity.DataModel.Data.Token = Token;
      this.Commodity.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Commodity.DataModel.Data);
      axios
        .post("APIScript/PHP/APIService/Commodity/Commodity.php", dataString)
        .then(function(response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.Commodity.Masters.CommodityList = response.data.Result;
            console.log(vm.Commodity.Masters.CommodityList);
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    }
  }
};
</script>
